// extracted by mini-css-extract-plugin
export default {"wrapper":"a6-z","play":"b6-z"};